export default () => {
    window.scrollTo({ top: 0 });
};
